import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import GameSvcCtntCtxtApi from "Apis/GameSvcCtntCtxtApi";
import sanitizeHtml from 'sanitize-html';
import MembQnaCtxtApi from "Apis/MembQnaCtxtApi";
import UseLangLstQuery from "Apis/LangTxtInqApi";

import "Assets/css/Trms.css";
import "Assets/css/Ctnt.css";
import { useLocation } from "react-router-dom";
import MgpStore from "Stores/Store";
import StarRateUi from "Utils/StarRateUi";
import { Helmet } from "react-helmet-async";
import ApiResultModal from "Components/ApiResultModal";

const QnaCtxtUi = ({gameSvcCd,ctntKindCd,qnaSno}:any) => {
    const {data: langData}:any = UseLangLstQuery();
    const location= useLocation(); 
    const navigate = useNavigate();
const [resultModalOpen, setResultModalOpen] = useState(false);
const [resultModalMessage, setResultModalMessage] = useState("");
const [modalAction, setModalAction] = useState<(() => void) | null>(null); 
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    let ctntCtgrCd = query.get("ctntCtgrCd");
    let getQnaSno = query.get("qnaSno");
    if(getGameSvcCd !=null){
        gameSvcCd = getGameSvcCd;
        ctntKindCd = ctntCtgrCd;
        qnaSno = getQnaSno;
    }

    if(gameSvcCd ==null) {
        gameSvcCd = location.state?.gameSvcCd;
    }
    if(ctntKindCd ==null) {
        ctntKindCd = location.state?.ctntKindCd;
    }
    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };
    const [qnaGameSvcCdState,setQnaGameSvcCdState] = useState();
    const [qnaCtgrNmState,setQnaCtgrNmState] = useState();
    const [ctntCtxtState,setCtntCtxtState] = useState<any>();
    const [qnaTitlState,setQnaTitlState] = useState<any>();
    const [aplyStrtDtimeState,setAplyStrtDtimeState] = useState<any>();
    const [atchFlNmState,setAtchFlNmState] = useState<any>();
    const [atchFlUrlState,setAtchFlUrlState] = useState<any>();
    const [qnaKindCdState,setQnaKindCdState] = useState("");
    const [starRtngYnState,setStarRtngYnState] = useState("");
    let test1:any;
    useEffect(()=>{
        MembQnaCtxtApi(getGameSvcCd,getQnaSno)
        .then((Resp) => {
            if(Resp.apiHdr.code !="MEMB0000") {
                openResultModal(`${Resp.apiHdr.msg}`,() => {
                    navigate(`/MyPage/QnaLst`);
                });
            }
            setQnaGameSvcCdState(Resp.apiBody.gameSvcNm)
            setQnaCtgrNmState(Resp.apiBody.ctntCtgrNm);
            setAplyStrtDtimeState(Resp.apiBody.qnaRegDtime);
            setQnaTitlState(Resp.apiBody.qnaTitl);
            setAtchFlNmState(Resp.apiBody.atchFlNm);
            setQnaKindCdState(Resp.apiBody.qnaKindCd);
            setStarRtngYnState(Resp.apiBody.starRtngYn);
            setAtchFlUrlState(Resp.apiBody.atchFlUrl);
            // 이스케이프된 \n을 실제 줄바꿈 문자로 변환
            const convertedText = Resp.apiBody.qnaCtxt.replace(/\\n/g, '\n');
            // \n을 <br> 태그로 변환
            const htmlText = convertedText.replace(/\n/g, '<br>');
            
            // 웹 에디터 내용을 그대로 보여주기 위해 최대한 허용
            const sanitizedHtml = sanitizeHtml(htmlText, {
                allowedTags: ['p', 'br', 'b', 'i', 'u', 'strong', 'em', 'font', 'img', 'div', 'span', 'style', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'a'],
                allowedAttributes: {
                    '*': ['style', 'class', 'id'],
                    'font': ['color', 'face', 'size'],
                    'img': ['src', 'width', 'height', 'alt'],
                    'a': ['href', 'target']
                },
                allowedStyles: {
                    '*': {
                        // 모든 CSS 속성 허용
                        'color': [/.*/],
                        'background-color': [/.*/],
                        'font-size': [/.*/],
                        'font-family': [/.*/],
                        'font-weight': [/.*/],
                        'text-align': [/.*/],
                        'margin': [/.*/],
                        'padding': [/.*/],
                        'width': [/.*/],
                        'height': [/.*/],
                        'display': [/.*/],
                        'text-decoration': [/.*/]
                    }
                }
            });
            setCtntCtxtState(sanitizedHtml);

        })
    },[MgpStore.getState().LangSetState.Lang]);
    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };
   
    return(
        <>
                <ApiResultModal
                    open={resultModalOpen}
                    message={resultModalMessage}
                    onClose={closeResultModal}
        confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
                />
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_MAIN_QNA_LST_BTN_00}`}</title>
        </Helmet>
        <div className= "container1300 BgW  pb200">
                <div className="myPageSubTitlWrap">
                    <p className="myPageCtxtTitl">{langData&&langData.MYPAGE_MAIN_QNA_LST_BTN_00}</p>
                </div>
                <div className="qnaTitlWrap qnaCtxtTitlWrap">
                    <h1>{qnaTitlState}</h1>
                    <div className="qnaCtxtCtgrWrap">
                        <div className="dFlex gap10">
                            <ul  className="dFlex gap10">
                                <li><p>{qnaGameSvcCdState}</p></li>
                                <li><p>{qnaCtgrNmState}</p></li>
                            </ul>
                            <p>{aplyStrtDtimeState}</p>
                        </div>
                    </div>
                </div>
                <div className="qnaTextareaWrap">
                    <div className="mh400 qnaContent" dangerouslySetInnerHTML={{__html: ctntCtxtState}}>
                    </div>
                </div>
                {atchFlNmState && atchFlNmState.trim() !== "" && (
                    <div  className="qnaTitlWrap">
                        <p className="qnaLbl mt10">{langData&&langData.MYPAGE_QNA_ATCH_FL_TITL_00}</p>
                        <div 
                            className="fileNameWithPreview"
                            onClick={(e) => {
                                if (window.innerWidth <= 1024) {
                                    e.currentTarget.classList.toggle('show');
                                }
                            }}
                        >
                            <p>{atchFlNmState}</p>
                            {(() => {
                                const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
                                const fileExt = atchFlNmState.split('.').pop()?.toLowerCase();
                                return imageExtensions.includes(fileExt || '') ? (
                                    <div className="imagePreviewTooltip">
                                        <img src={atchFlUrlState} alt={atchFlNmState} />
                                    </div>
                                ) : null;
                            })()}
                        </div>
                    </div>
                )}
                {}
                {qnaKindCdState&&qnaKindCdState == "Q" ?
                    <div className="ctntBtnWrap qnaCtntBtnWrap dFlex">
                        <Link to={`/MyPage/QnaLst`}>
                            <p>{langData&&langData.GLB__COMM_LST_BTN_00}</p>
                        </Link>
                    </div>:
                        starRtngYnState&&starRtngYnState == "N"?
                        <StarRateUi 
                            langData={langData&&langData} 
                            gameSvcCd={qnaGameSvcCdState} 
                            qnaSno={getQnaSno} 
                            starRtngYn={starRtngYnState}
                            onStarRateComplete={() => setStarRtngYnState("Y")}
                        />
                        :
                        <>
                        </>
                }
        </div>
        </>
    )
}

export default QnaCtxtUi;
